import React from 'react';

import { DetailPageLayout } from 'src/components/common';
import { PeoPayrollProviderLiveStatusWrapper } from 'src/components/peoPayrollProvider';

export const PeoPayrollProviderDetailLiveStatusPage: React.FC = () => {
  return (
    <DetailPageLayout titleContent='Settings / "Is Live" Status'>
      <PeoPayrollProviderLiveStatusWrapper />
    </DetailPageLayout>
  );
};
